import demoModeConfig from "./demoModeConfig.json";
import {
  hasWencoDemoModeAccess,
  isWencoDemoModeEnabled,
  setWencoDemoModeEnabled
} from "./wencoDemoMode";

export function hasDemoModeAccess(managedLogisticCompanies = {}) {
  return demoModeConfig.enabledForLogisticCompanyIds.some(
    id => !!managedLogisticCompanies[id]
  );
}

export function isDemoModeEnabled() {
  try {
    return localStorage.getItem(demoModeConfig.storageKey) === "true";
  } catch (error) {
    return false;
  }
}

export function setDemoModeEnabled(enabled) {
  try {
    localStorage.setItem(demoModeConfig.storageKey, String(Boolean(enabled)));
  } catch (error) {
    // ignore storage errors
  }
}

export function readDemoModeState(managedLogisticCompanies = {}) {
  return {
    hasDemoModeAccess: hasDemoModeAccess(managedLogisticCompanies),
    hasWencoDemoAccess: hasWencoDemoModeAccess(managedLogisticCompanies),
    demoModeEnabled: isDemoModeEnabled(),
    wencoDemoModeEnabled: isWencoDemoModeEnabled()
  };
}

export {
  hasWencoDemoModeAccess,
  isWencoDemoModeEnabled,
  setWencoDemoModeEnabled
};
